import { render, staticRenderFns } from "./chat_query_by_user.vue?vue&type=template&id=1752970b&scoped=true"
import script from "./chat_query_by_user.vue?vue&type=script&lang=js"
export * from "./chat_query_by_user.vue?vue&type=script&lang=js"
import style0 from "./chat_query_by_user.vue?vue&type=style&index=0&id=1752970b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1752970b",
  null
  
)

export default component.exports